module.exports = __webpack_public_path__ + "img/map-marker-alt.2931262f.png";